import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';

const OperatorActionErrorModal = ({
  error,
  onRetry,
  onCancel,
  onRetryWithCancelSubscription,
  onMoveAndDeleteOperator,
  // Optional. When supplied, the "would leave the organization without users" case also
  // offers keeping the empty organization instead of only deleting it.
  onKeepOrganization,
  retryWithCancelLabel
}) => {
  if (!error) return null;

  const isActiveSubscriptionsError = error.error === 'organization_has_active_subscriptions' || error.error === 'operator_has_active_subscriptions';
  const isMoveAndDeleteError = error.error === 'require_move_and_delete_organization';
  const isAssignedUsersError = error.error === 'organization_has_assigned_users' || error.error === 'operator_has_assigned_users';

  const getErrorMessage = () => {
    if (isActiveSubscriptionsError) {
      return retryWithCancelLabel
        ? `This organization has active subscriptions that need to be handled. You can retry after canceling the subscriptions in Stripe.`
        : `This organization has active subscriptions that need to be handled. You can retry after canceling the subscriptions in Stripe, or choose to retry and automatically cancel the subscriptions.`;
    } else if (isMoveAndDeleteError) {
      return onKeepOrganization
        ? `This action would leave the organization without users. Choose whether to keep the empty organization or delete it along with this change.`
        : `This action would leave the organization without users. To proceed, the affected user will be moved to the new organization and the current organization will be deleted.`;
    } else if (isAssignedUsersError) {
      return `This organization has assigned users that must be handled before deletion. Please reassign or remove the users first.`;
    }
    return 'An error occurred while processing your request.';
  };

  return (
    <Dialog
      open={true}
      onClose={onCancel}
      aria-labelledby="error-dialog-title"
      aria-describedby="error-dialog-description"
    >
      <DialogTitle id="error-dialog-title">
        {isActiveSubscriptionsError && 'Active Subscriptions Detected'}
        {isMoveAndDeleteError && 'Organization Deletion Required'}
        {isAssignedUsersError && 'Organization Has Assigned Users'}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="error-dialog-description">
          {getErrorMessage()}
        </DialogContentText>
        {error.active_subscriptions && error.active_subscriptions.length > 0 && (
          <DialogContentText style={{ marginTop: '16px', fontWeight: 'bold' }}>
            Active Subscriptions: {error.active_subscriptions.length}
          </DialogContentText>
        )}
      </DialogContent>
      <DialogActions>
        {isActiveSubscriptionsError && (
          <>
            {!retryWithCancelLabel && (
              <Button onClick={onCancel}>Cancel</Button>
            )}
            <Button onClick={onRetry} color="primary">
              Retry
            </Button>
            <Button onClick={onRetryWithCancelSubscription} color="warning" variant="contained">
              {retryWithCancelLabel || 'Retry and Cancel Subscription'}
            </Button>
          </>
        )}
        {isMoveAndDeleteError && (
          <>
            <Button onClick={onCancel}>Cancel</Button>
            {onKeepOrganization && (
              <Button onClick={onKeepOrganization} color="primary" variant="contained">
                Keep Organization
              </Button>
            )}
            <Button onClick={onMoveAndDeleteOperator} color="warning" variant="contained">
              Move and Delete Organization
            </Button>
          </>
        )}
        {isAssignedUsersError && (
          <>
            <Button onClick={onCancel}>Cancel</Button>
          </>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default OperatorActionErrorModal;

